import { http } from '@/services/http'
import type { Company } from '@/services/company/company.service'

export interface CreateAdminRequest {
  name: string
  email: string
  password: string
}

export interface CreateAdminResponse {
  access_token: string
  user: {
    id: string
    name: string
    email: string
  }
}

export interface UpdateCompanyOnboardingData {
  telefone?: string
  cnpjCpf?: string
  cep?: string
  rua?: string
  numero?: string
  complemento?: string
  bairro?: string
  cidade?: string
  estado?: string
  useFinancial?: boolean
}

export const onboardingService = {
  createAdmin: async (data: CreateAdminRequest): Promise<CreateAdminResponse> => {
    return http.post<CreateAdminResponse>('/onboarding/create-admin', data)
  },

  updateCompany: async (data: UpdateCompanyOnboardingData): Promise<Company> => {
    return http.patch<Company>('/onboarding/company', data)
  },

  skipStep: async (): Promise<void> => {
    return http.patch<void>('/onboarding/skip')
  },

  completeOnboarding: async (): Promise<void> => {
    return http.patch<void>('/onboarding/complete')
  },
}
